// i18n area 'networks' — locale cs-CZ (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.cs-CZ.meta.json.
import type { enUS } from './networks'

export const csCZ: typeof enUS = {
  networks: {
    common: {
      name: 'Název',
      scope: 'Scope',
      operState: 'Stav',
      actions: 'Akce',
      create: 'Vytvořit',
      close: 'Zavřít',
      cancel: 'Zrušit',
      delete: 'Odstranit',
      edit: 'Upravit',
      save: 'Uložit',
      editError: 'Úprava se nezdařila',
      search: 'Hledat podle názvu',
      empty: 'Zatím tu nic není',
      saveError: 'Nepodařilo se uložit',
      loadError: 'Nepodařilo se načíst — je backend TVirt dosažitelný?',
      createError: 'Vytvoření se nezdařilo',
      deleteError: 'Odstranění se nezdařilo',
      deleteConfirmTitle: 'Odstranit {name}?',
      deleteConfirmBody: 'Operace je nevratná.',
      nameHint: 'Malá písmena, číslice a pomlčky (DNS-1123)',
      up: 'Aktivní',
      down: 'Neaktivní',
      unknown: 'Neznámý',
      usedByVMs: 'VM',
      emptyTable: 'Žádná položka — přidejte ji tlačítkem +'
    },
    dialogTabs: {
      general: 'Obecné',
      base: 'Základní definice',
      advanced: 'Pokročilá konfigurace',
      reserved: 'Rozsahy vyhrazené pro TVirt',
      position: 'Pozice',
      network: 'Síťová konfigurace',
      hosts: 'Zúčastněné uzly'
    },
    reservedRanges: {
      note: 'Toto jsou rozsahy IP vyhrazené pro TVirt, ze kterých může automaticky přidělovat adresy VM, kontejnerům atd. POZNÁMKA: IP z těchto rozsahů nesmí mimo TVirt používat externí služby ani zařízení.',
      from: 'Od',
      to: 'Do'
    },
    overlay: {
      title: 'Overlay sítě',
      createTitle: 'Vytvořit overlay síť',
      editTitle: 'Upravit overlay síť',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — pokud je prázdný, přidělí se automaticky',
      subnet: 'Podsíť',
      subnetHint: 'CIDR overlay sítě — IPAM z něj automaticky odvodí záznam v evidenci',
      mtu: 'MTU',
      weight: 'Váha',
      ceilMbps: 'Strop (Mbps)',
      fairnessHint: 'Váha se uplatní jen při souběhu: na volné lince může každá síť využít celou šířku pásma. Strop však platí vždy.',
      contention: 'Soupeření',
      contentionTip: 'Alespoň jeden uzel pozoruje zahazování nebo overlimity S frontou na třídě této sítě: pásmo uplinku je sdílené pod tlakem a váhy působí. Kolik a odkdy říkají řady net.shaping.* uzlu.',
      firewallPolicy: 'Politika firewallu',
      hosts: 'Hostitelé',
      hostsTitle: 'Zúčastněné uzly',
      hostsHint: 'Každý uzel deklaruje svůj underlay endpoint — select nad SKUTEČNÝMI adresami uzlu, čtenými z jeho síťové konfigurace; volitelná adresa v overlay síti musí ležet v podsíti. Účast je omezením umístění.',
      hostNode: 'Uzel',
      hostUnderlay: 'Underlay IP',
      hostUnderlayPickNode: 'Nejdřív vyberte uzel',
      hostAddress: 'Adresa v overlay síti (volitelná)',
      hostAddressOutside: 'Mimo subnet overlaye ({cidr})',
      addHost: 'Přidat uzel',

      // Round #156 (standardní dialog): pozorované řádky dialogu detailu.
      observedAt: 'Pozorováno',
      attachedNics: 'Připojené NIC'
    },
    services: {
      title: 'Síťové služby',
      createTitle: 'Vytvořit síťovou službu',
      editTitle: 'Upravit síťovou službu',
      kind: 'Typ',
      kindCategory: 'Služby',
      selectKindHint: 'Vyberte typ služby — daemon pod ní je implementační detail, který TVirt spravuje za vás.',
      kindLabel: {
        dhcp: 'Server DHCP',
        ntp: 'Server NTP',
        vpn: 'Server VPN',
        dns: 'Server DNS',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer a reverse proxy',
        floatip: 'Plovoucí IP'
      },
      kindDesc: {
        dhcp: 'Přiděluje adresy na obsluhovaných podsítích — pooly se odvozují z podsítě, gateway a rozsahů sítě vyhrazených pro TVirt.',
        dns: 'Autoritativní DNS nad deklarovanými zónami — záznamy se odvozují z IPAM plus vaše ruční.',
        gateway: 'Uzel dělá gateway pro síť — NAT (DNAT, 1:1, SNAT/masquerade) plus statické směrování mezi připojenými sítěmi, již z návrhu samoopravné.',
        'lb-rp': 'Load balancer / reverzní proxy před vašimi službami — L4 nebo L7 listenery nad pooly členů nebo nad připravenými instancemi Podu, překonfigurované za běhu.',
        ntp: 'Časová služba sítí — relay externích upstream serverů, nebo hodiny uzlu poskytované klientům.',
        vpn: 'VPN koncentrátor na uzlu — WireGuard nebo OpenVPN, vyberete si: vzdálený přístup pro cestující klienty, nebo site to site tunel mezi dvěma sítěmi.',
        floatip: 'Jedna adresa, která sedí vždy jen na jedné zdravé instanci App nebo Podu a přesune se na další zdravý cíl, když ten padne — failover bez démonů; vyvažování zůstává load balanceru.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Plovoucí IP žije ve zvolené síti jako DALŠÍ adresa uvnitř jmenného prostoru držící instance: žádné porty, žádné vyvažování, žádný NAT — IP klienta zůstává pravá.',
        address: 'Plovoucí IP',
        targets: 'Cíle',
        targetsHint: 'V pořadí PREFERENCE: první zdravý cíl drží adresu. Pod znamená všechny jeho instance, po replikách; každý cíl má vlastní kritérium zdraví. Každý cíl musí být připojen ke stejné síti.',
        targetKind: 'Cíl',
        targetApp: 'Instance App',
        targetPod: 'Pod (všechny instance)',
        targetRef: 'Který',
        health: 'Zdraví',
        healthRunning: 'Běží (každý kontejner připraven)',
        healthTcp: 'TCP připojení',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Cesta',
        addTarget: 'Přidat cíl',
        moveUp: 'Posunout výš',
        moveDown: 'Posunout níž',
        preempt: 'Preempt',
        preemptHint: 'Vypnuto (výchozí): zdravý držitel si adresu nechá, i když se vrátí vyšší cíl — žádné přepínání. Zapnuto: adresu drží vždy první zdravý cíl.',
        holder: 'Držitel',
        noHolder: 'žádný zdravý cíl',
        since: 'od',
        verdicts: 'Pozorované cíle',
        healthy: 'zdravý',
        unhealthy: 'nezdravý',
        noVerdict: 'Zatím nerozhodnuto — autoritativní uzel zapíše první verdikt při dalším průchodu.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Tato instance drží plovoucí IP {address} služby {service}'
      },
      poolSource: 'Endpointy',
      poolSourceMembers: 'Statičtí členové',
      poolSourcePod: 'Připravené instance Podu',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Endpointy následují Pod: instance vstoupí, když běží s každým kontejnerem připraveným, a ihned odejde, když je zmenšena nebo umře. Aktivní kontrola je ve výchozím stavu zapnutá.',
      poolBackendCount: 'připravené instance Podu {pod} na portu {port}',
      node: 'Uzel',
      enabled: 'Povoleno',
      parked: 'Zaparkováno',
      subnets: 'Podsítě',
      subnetsHint: 'Podsítě IPAM obsluhované touto instancí — pooly se odvozují z CIDR, gateway a rozsahů vyhrazených pro TVirt',
      noSubnets: 'Žádná podsíť IPAM — nejdřív deklarujte logickou síť fabricu (nebo overlay podsíť): IPAM se odvozuje z nich',
      iface: 'Naslouchací rozhraní',
      ifaceHint: 'Hostitelské rozhraní, na kterém služba otevírá svůj socket (např. bridge) — povinné: síťová služba je soběstačná, „všechna rozhraní" už neexistují',
      dns: 'Servery DNS',
      domain: 'Doména',
      detail: 'Obsluhuje',
      subnetCount: 'podsítí: {n}',
      zones: 'Zóny',
      zonesHint: 'Pouze autoritativní — daemon nikdy nerekurzuje. Záznamy A se odvozují z deklarovaných adres uzlů v odkazovaných podsítích IPAM; přepínač reverse obsluhuje i odpovídající zóny in-addr.arpa (PTR). Zónu obsluhuje nejvýše jedna instance DNS ve flotile. Volitelný nameserver je FQDN zapsaný do záznamů NS/SOA místo defaultu ns.<zóna>; pokud padne dovnitř zóny, jeho záznam A se stejně odvodí z obsluhujícího uzlu.',
      zoneName: 'Název zóny',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'Podsítě IPAM',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Ruční záznamy',
      zoneRecordsHint: 'Jeden na řádek: název TYP hodnota — typy A, CNAME, MX, TXT. Při kolizi na názvu vítězí ruční záznam nad odvozeným.',
      addZone: 'Přidat zónu',

      // lb-rp (základy vlny 3): listenery nad inline pooly — engine-less,
      // rekonfigurované za běhu.
      lbListeningHint: 'Instance deklaruje JEDNU naslouchací síť a JEDNU adresu — každý listener ji váže na svém portu; druhá adresa je druhá služba.',
      listeners: 'Listenery',
      listenersHint: 'Každý listener váže adresu instance na svém portu v režimu L4 (TCP passthrough — bajty se nikdy neotvírají) nebo L7 (HTTP) a předává do jednoho z poolů níže. Dvojici adresa/port obsluhuje nejvýše jedna instance na uzel. Změny se aplikují za běhu — žádný restart, žádné ztracené spojení.',
      listenerName: 'Název',
      listenerMode: 'Režim',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP passthrough',
      listenerPort: 'Port',
      listenerPool: 'Pool',
      addListener: 'Přidat listener',
      pools: 'Pooly',
      poolsHint: 'Backendy, na kterých přistává provoz: statičtí členové balancovaní round-robin nebo podle nejmenší zátěže, s volitelným aktivním health checkem, který vyřadí z rotace nezdravé členy.',
      poolName: 'Název',
      poolAlgorithm: 'Algoritmus',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Nejméně vytížený',
      poolCheck: 'Health check',
      checkNone: 'Žádný',
      checkTcp: 'Spojení TCP',
      checkHttp: 'HTTP',
      poolCheckPath: 'Cesta sondy',
      poolInterval: 'Interval (s)',
      poolMembers: 'Členové',
      poolMembersHint: 'Jeden na řádek: adresa:port, volitelně následované váhou (1-128) — např. 10.0.0.21:8080 2',
      addPool: 'Přidat pool',
      memberCount: 'členů: {n}',

      // ntp (round ntp — ratifikace 2026-08-03, poslední kind rodiny):
      // režim řečený lidsky, seznam upstreamů jen tam, kde něco znamená,
      // síťové připojení přebírá popisky gatewaye.
      // #239 (soběstačné netsvc): sdílený editor seznamu listenerů
      // kindů dns a ntp — dvě ratifikované multi-síťové výjimky.
      listen: {
        assignment: 'Přidělení',
        assignmentStatic: 'Statická adresa',
        assignmentAuto: 'Automatické (rezervované rozsahy TVirt)',
        autoHint: 'TVirt vytáhne adresu z rezervovaných rozsahů logické sítě a drží ji sticky — nikdy znovu netažena při editaci nebo failoveru.',
        title: 'Listenery',
        hint: 'Síťová služba je soběstačná: každý listener deklaruje svou síť (overlay, logickou síť fabricu nebo rozhraní) a adresu uvnitř její podsítě — jeden listener na adresu, wildcard už neexistuje. DNS a NTP mohou naslouchat na více sítích a na více adresách těchto sítí.',
        address: 'Adresa naslouchání',
        add: 'Přidat listener'
      },
      ntp: {
        mode: 'Režim synchronizace',
        modeRelay: 'Relay externích serverů',
        modeNodeClock: 'Hodiny uzlu',
        modeHint: 'Relay poskytuje čas převzatý z deklarovaných upstream serverů; hodiny uzlu poskytují čas obsluhujícího uzlu — který klastr beztak drží synchronizovaný',
        servers: 'Upstream servery',
        serversHint: 'Oddělené čárkou — hostname nebo IP adresa; služba si odsud bere čas a poskytuje ho síti',
        port: 'Port naslouchání',
        listening: 'Naslouchá na'
      },

      vpn: {
        engine: 'Engine',
        engineHint: 'Vyberete si ho vy a už se nemění: WireGuard je moderní, rychlý a in-kernel; OpenVPN je veterán kompatibility (TCP, nepřátelské sítě)',
        engineLocked: 'Engine je neměnný — jiný engine je nová služba, klíče a certifikáty nejsou přenosné',
        mode: 'Režim',
        modeRemote: 'Vzdálený přístup',
        modeSite: 'Site to site',
        modeHint: 'Vzdálený přístup dává cestujícím klientům adresu v tunelu; site to site spojuje dvě sítě',
        port: 'Port naslouchání',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard mluví jen UDP',
        tunnelSubnet: 'Podsíť tunelu',
        tunnelSubnetHint: 'Síť, ve které žijí klienti — zapsaná v evidenci IPAM, rodí se a umírá s touto službou',
        dnsServers: 'DNS předávané klientům',
        routes: 'Trasy předávané klientům',
        routesHint: 'Sítě oddělené čárkou dosažitelné v tunelu; podsíť tunelu je vždy zahrnuta',
        peers: 'Peery',
        peersHint: 'Nechte veřejný klíč prázdný a TVirt vygeneruje pár — pak ho předá s profilem. Vložte klíč a peer si nechá svůj.',
        clients: 'Klienti',
        clientsHint: 'Každý klient dostane certifikát vydaný CA této služby. Odebrání klienta ho ODVOLÁ: CRL se hned přegeneruje.',
        peerName: 'Název',
        publicKey: 'Veřejný klíč',
        publicKeyMinted: 'Vygeneruje ho TVirt',
        peerAddress: 'Adresa v tunelu',
        peerAddressHint: 'Prázdné = přidělená',
        allowedIps: 'Vzdálené podsítě',
        allowedIpsHint: 'Oddělené čárkou, směrované přes tento peer',
        endpoint: 'Endpoint',
        presharedKey: 'Předsdílený klíč',
        keepalive: 'Keepalive (s)',
        addPeer: 'Přidat peer',
        addClient: 'Přidat klienta',
        auth: 'Autentizace',
        authTls: 'Certifikáty (TLS)',
        remote: 'Vzdálený endpoint',
        remoteHint: 'host:port vzdáleného konce — prázdné znamená, že tato strana čeká',
        peerRoutes: 'Vzdálené podsítě',
        serverPublicKey: 'Veřejný klíč tohoto serveru',
        ca: 'Certifikační autorita',
        listening: 'Naslouchá na',
        tunnel: 'Tunel',
        peerCount: 'peerů: {n}',
        download: 'Stáhnout profil',
        downloadError: 'Profil se nepodařilo exportovat',
        lastHandshake: 'Poslední handshake',
        never: 'nikdy',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Připojen',
        idle: 'Nečinný'
      },

      // Gateway (vlna 3 — zrozen jako nat, ratifikace 2026-08-01/02;
      // přejmenován a rozšířen 2026-08-03): tři rodiny pravidel NAT plus
      // statické trasy nad naslouchací sítí. Každá ratifikovaná forma je podporována.
      gateway: {
        attach: 'Typ naslouchací sítě',
        attachOverlay: 'Overlay síť',
        attachNetwork: 'Logická síť fabricu',
        attachInterface: 'Surové rozhraní',
        overlay: 'Overlay síť',
        network: 'Logická síť',
        interface: 'Název rozhraní',
        interfaceHint: 'Hostitelské rozhraní, které TVirt nespravuje — adresa se bere tak, jak je',
        address: 'Adresa naslouchání (gateway)',
        addressHint: 'Adresa gateway, na kterou míří klienti — uvnitř podsítě naslouchací sítě',
        dnatTitle: 'Pravidla DNAT',
        dnatHint: 'Cílový NAT: provoz odpovídající matchi je přesměrován na novou adresu (a volitelně nový port). Kterýkoli protokol ze seznamu — porty tam, kde je protokol nese.',
        snatTitle: 'Pravidla SNAT',
        snatHint: 'Zdrojový NAT: provoz odpovídající matchi odchází s přepsaným zdrojem — nová explicitní adresa (a volitelně nový port), nebo masquerade na odchozí adresu, když zůstane prázdné.',
        oneToOneTitle: 'Pravidla 1:1 NAT',
        oneToOneHint: 'Každý paket na externí adresu se mapuje na interní a interní host odchází jako externí — všechny protokoly, oba směry.',
        external: 'Externí adresa',
        internal: 'Interní adresa',
        addOneToOne: 'Přidat pravidlo 1:1',
        family: 'Rodina',
        protocol: 'Protokol',
        source: 'Zdroj (adresa/podsíť)',
        destination: 'Cíl (adresa/podsíť)',
        invert: 'NOT',
        srcPorts: 'Zdrojové porty',
        dstPorts: 'Cílové porty',
        dstPortsHint: 'Port nebo rozsah (80, 8000-8099)',
        toAddress: 'Nová adresa',
        toPort: 'Nový port',
        snatTo: 'Nový zdroj (prázdné = masquerade)',
        snatToHint: 'Explicitní zdrojová adresa; prázdné = masquerade na odchozí adresu',
        addDnat: 'Přidat pravidlo DNAT',
        addSnat: 'Přidat pravidlo SNAT',
        routesTitle: 'Statické trasy',
        routesHint: 'Uzel směruje mezi sítěmi, ke kterým je připojen (IP forwarding je zapnutý); tyto trasy přidávají dosažitelnost nad jejich rámec — čistý kernel, dynamické směrování přijde v pozdějším roundu.',
        routeDestination: 'Cílová podsíť',
        routeGateway: 'Next hop',
        routeMetric: 'Metrika',
        addRoute: 'Přidat trasu',
        listening: 'Naslouchá na',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · trasy: {r}'
      },
      unknownSince: 'Neznámý — poslední hlášení před {m} min',
      lastWord: 'Poslední slovo',

      // Round #156 (standardní dialog): pozorované řádky a souhrn bloku
      // kind jen pro čtení v dialogu detailu.
      reportObservedAt: 'Poslední hlášení',
      lastErrorRow: 'Poslední chyba',
      recordsCount: 'ručních záznamů: {n}',
      phase: {
        configured: 'Nakonfigurováno',
        running: 'Běží',
        error: 'Chyba'
      },
      authorityNode: 'Authority (přiřazení)',
      preferredNode: 'Preferovaný uzel',
      preferredNodeHint: 'Měkká preference, nikdy omezení: při příštím rozhodnutí o placementu instance přistane zde, pokud je tento člen způsobilý — sama o sobě nic nepřesune; tahem je „Přenést authority".',
      noPreference: 'Bez preference (automatický placement)',
      moving: 'V pohybu',
      movingTooltip: 'Pozorována zde, zatímco authority přiřazuje {node}: přesun právě konverguje.',
      placement: {
        title: 'Placement',
        loading: 'Probíhá sčítání…',
        loadError: 'Sčítání placementu neodpovědělo — zkuste to později.',
        draftHint: 'Sčítání se počítá z deklarovaného připojení sítě: objeví se, jakmile služba vznikne. Vytvoření je odmítnuto, když ji žádný člen nemůže obsloužit, a odmítnutí jmenuje mechanismus, který množinu vyprázdnil.',
        eligibleCount: '{n} z {m} členů může tuto instanci obsloužit',
        recommended: 'Doporučený',
        eligible: 'Způsobilý',
        notEligible: 'Nezpůsobilý',
        blockedReachability: 'síť k tomuto členovi nedosáhne',
        blockedRequireTag: 'blokován povinným tagem (requireNodes)',
        blockedExcluded: 'vyloučen simulací',
        preferenceUnknown: 'není (už) členem klastru',
        preferenceIgnored: 'Preference „{node}" dnes není způsobilá: {reason}. Přednost má doporučení sčítání — nikdy chyba, služba žije jinde.',
        emptyReachability: 'Žádný člen nemůže tuto instanci obsloužit: síť nedosáhne nikam — žádná úprava tagů nepomůže. Zapojte uzel kabelem, nebo službu přesuňte tam, kde síť je.',
        emptyRequireTag: 'Žádný člen nemůže tuto instanci obsloužit: množinu vyprázdnily povinné tagy — odeberte položku z requireNodes, nebo otagujte některého člena.',
        spof: 'Jediný bod selhání',
        spofDetail: 'Instanci může hostit jen jediný člen: při selhání nemá failover kam jít. Služba s více listenery se stěhuje jako CELEK — kandidát musí vidět VŠECHNY její sítě: to je ta cena.',
        whatIf: 'Simulovat nepřítomné členy',
        whatIfHint: 'What-if drainu: zeptejte se PŘED evakuací, ať to neobjevíte až při failoveru.',
        survives: 'Bez {nodes} má služba pořád domov.',
        notSurvives: 'Evakuace {nodes} nechá tuto službu MIMO PROVOZ: odvozené omezení vítězí nad dostupností (R30) — démon živý tam, kam síť nedosáhne, nikomu neslouží a nikoho nealarmuje.',
        transfer: 'Přenést authority',
        transferError: 'Přenos se nezdařil',
        transferTarget: 'Cílový člen',
        transferHint: 'Nabízejí se jen způsobilí členové — preference uvnitř platné množiny, nikdy override. Žádná úloha: příští průchod workerů JE ten přesun (starý uzel sklízí, nový realizuje).'
      }
    },
    fabric: {
      tabDerivation: 'Derivace',
      importNetwork: 'Importovat z jiného fabricu',
      importTitle: 'Importovat logickou síť',
      importHint: 'Import je výslovné přistoupení: síť zůstává vlastníkovi (stejná identita, stejný stem, stejný bridge tvf-<stem>) a odtud se mapuje na porty/LAGG tohoto fabricu — mapovat ZNAMENÁ tvrdit, že doručení ústí do stejné L2 domény jako u vlastníka.',
      importPick: 'Síť vlastníka',
      importNone: 'Není co importovat: ostatní fabricy nemají vlastní síť, kterou by tento fabric už neznal',
      importedNetworksTitle: 'Importované sítě',
      noImported: 'Žádná importovaná síť',
      importedFrom: 'importována z {fabric}',
      importedBy: 'Importována do: {list}',
      importedCount: '+{n} importovaných',
      owner: 'Vlastník',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Odebrat import',
      unimportConfirm: 'Odebrat import sítě {name} (vlastník {fabric}) z tohoto fabricu? Je odmítnuto, dokud ji mapuje port nebo LAGG tohoto fabricu, nebo je host, App či služba obsluhován jen přes tuto nohu.',
      unimportRefused: 'Import se stále používá — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Tento uzel už tuto síť bere z jiného fabricu, jehož je členem: uzel bere sdílenou síť jen z JEDNÉ ze svých noh (dva uplinky téhož L2 v bridgi bez STP jsou smyčka). Odmapuj ji na portech nebo LAGG jednoho ze dvou fabriců.',
          otherFabricDerived: 'Dokument nese blok fabricu, ke kterému uzel už nedeklaruje žádný kabel: nejprve aplikuj plán toho fabricu (navrhuje odstranění jeho zařízení), nebo je převezmi přes take-ownership, pokud fabric už neexistuje.'
        },
        hint: 'Plán derivace O.3: pro každý zakabelovaný uzel stav, diff odvozené-vs-aktuální, DEKLAROVANÁ topologie bondů, dual-stack flipy a strukturovaná odmítnutí/varování. Jen ke čtení až do EXPLICITNÍHO apply — nic nikdy nepřistane na uzlu samo.',
        refresh: 'Znovu načíst plán',
        empty: 'Žádný uzel není k této fabric zakabelován (a žádný už nenese její blok).',
        refusal: 'Odmítnutí',
        warning: 'Varování',
        generation: 'generace dokumentu {n}',
        state: {
          manual: 'Ruční',
          derived: 'Odvozený',
          diverged: 'Odchýlený'
        },
        topologyTitle: 'Deklarovaná topologie',
        members: 'členové',
        primary: 'primární',
        held: 'držen na JEDNOM členu',
        form: {
          perNetworkBond: 'Bond na síť',
          singleBond: 'Jediný záložní bond',
          laggBond: 'LACP bond (LAGG)',
          singlePort: 'Jediný port'
        },
        colAction: 'Akce',
        colKind: 'Druh',
        colDevice: 'Device',
        colDetail: 'Detail',
        action: {
          add: 'přidat',
          remove: 'odebrat',
          replace: 'nahradit'
        },
        diffEmpty: 'Žádný čekající diff — aplikovaný dokument se shoduje s renderem.',
        diffBlocked: 'Žádný diff: odmítnutí výše blokují tento uzel.',
        phasePlanned: 'naplánováno (krok 1 ze 3)',
        phaseDraining: 'vyprazdňuje se (krok 2 ze 3)',
        probeUnobserved: 'Sonda vyprazdňování: nikdy nehlášena — prázdnota je NEZNÁMÁ (retire by byl nyní odmítnut).',
        probeFailed: 'Sonda vyprazdňování: pozorování SELHALO — známé časové značky se přenášejí, nikdy «prázdno», které nikdo neměřil.',
        probeActive: {
          one: 'Sonda: {n} navázané spojení stále na staré adrese',
          few: 'Sonda: {n} navázaná spojení stále na staré adrese',
          many: 'Sonda: {n} navázaného spojení stále na staré adrese',
          other: 'Sonda: {n} navázaných spojení stále na staré adrese'
        },
        probeLastActive: 'poslední aktivita {time}',
        probeEmpty: {
          one: 'Sonda: prázdno {n} minutu',
          few: 'Sonda: prázdno {n} minuty',
          many: 'Sonda: prázdno {n} minuty',
          other: 'Sonda: prázdno {n} minut'
        },
        probeEmptyUnknown: 'Sonda: prázdno (odkdy, neznámo).',
        impact: '{nics} vNIC a {apps} App na tomto uzlu používají tyto sítě: {list}',
        apply: 'Aplikovat na tento uzel',
        applyTitle: 'Aplikovat derivaci — {node}',
        applyIntro: 'Odvozená konfigurace přepisuje síťový dokument uzlu {node} ({n} změn) stejnými dveřmi jako editor host-network — checkpoint NetworkManageru a poctivá sonda včetně. Varování plánu níže cestují s aktem: přečtěte si je před potvrzením.',
        applyError: 'Apply selhal',
        applyRefused: 'Uzel odmítl:',
        planMoved: 'Fabric se po tomto náhledu změnila — NIC nebylo aplikováno. Plán byl znovu načten: podívejte se znovu a zkuste to znovu.',
        retire: 'Vyřadit',
        retireTitle: 'Bod, odkud není návratu — vyřazení {address}',
        restore: 'Obnovit',
        restoreTip: 'Zpět na snapshot před apply (generace {previous}) — undo o jeden krok (H13)',
        restoreTitle: 'Obnovit předchozí dokument — {node}',
        restoreIntro: 'Síťový dokument uzlu {node} se vrátí ke snapshotu pořízenému před posledním apply (generace {previous}), přepsanému jako generace {next} místo {current}. Worker jej sladí jako každý jiný dokument.',
        restoreRedo: 'Nahrazený dokument se stává novým snapshotem: opětovné obnovení je redo.',
        restoreClosesChain: 'Snapshot je ruční dokument před derivací: řetěz se zde uzavírá — žádné další undo, uzel je ruční až do dalšího apply.',
        restoreConfirm: 'Obnovit',
        restoreError: 'Obnovení se nezdařilo',
        retireIntro: 'Toto odstraní {address} ({network}) z {point} definitivně. Po tomto aktu je cestou zpět OBRÁCENÝ flip — znovudeklarace staré adresy stejným strojem — nikdy slepá obnova.',
        retireOld: 'Stará adresa (odstraněna)',
        retireNew: 'Nová adresa (zůstává)',
        retireEmptyFact: 'Sonda vyprazdňování hlásí adresu prázdnou: toto odstranění nepřeruší žádné pozorované spojení.',
        retireConfirm: 'Vyřadit adresu',
        severActiveLoss: {
          one: 'Přerušit {n} navázané spojení stále na staré adrese — umírá s tímto aktem',
          few: 'Přerušit {n} navázaná spojení stále na staré adrese — umírají s tímto aktem',
          many: 'Přerušit {n} navázaného spojení stále na staré adrese — umírají s tímto aktem',
          other: 'Přerušit {n} navázaných spojení stále na staré adrese — umírají s tímto aktem'
        },
        severUnknownLoss: 'Přijmout NEZNÁMÉ: sonda tuto adresu nikdy nepozorovala (nebo pozorování selhává) — živá spojení mohou být přerušena.'
      },
      title: 'Fabric',
      createTitle: 'Vytvořit fabric',
      networks: 'Sítě',
      switches: 'Přepínače',
      ports: 'Porty',
      laggs: 'LAGG',
      subnets: 'Podsítě',
      tabOverview: 'Přehled',
      tabNetworks: 'Logické sítě',
      tabSwitches: 'Přepínače',
      overviewHint: 'Fabric v kostce: každá logická síť s MTU a podsítí (VLAN žijí jen v mapováních na port/na LAGG — tatáž síť může na různých portech cestovat s různými tagy). Fabric je evidence EXTERNÍ infrastruktury — TVirt pozoruje a deklaruje, nikdy neprovisionuje, a sahá jen na registrované NIC pod svou kontrolou.',
      absorptionHint: 'Každá podsíť deklarovaná zde ODVOZUJE svůj záznam v evidenci IPAM v témže zápisu — žije a umírá se sítí.',
      scopeFixedHint: 'Scope je pevně daný — kořen clusteru: fyzická infrastruktura je z definice celoclusterová.',
      networksHint: 'Každá síť nese povinné MTU (default 1500) a povinnou podsíť; gateway, servery DNS a statické trasy deklarované zde jsou JEDINÝ ZDROJ pro NIC serverů, Aplikace a síťové služby.',
      switchesHint: 'Ruční evidence: port je nepoužitý, namapovaný (untagged provoz a provoz podle VLAN tagů na logické sítě) nebo člen LAGGu — člen nenese vlastní mapování.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Povinný — IPAM z něj automaticky odvodí záznam v evidenci',
      nodeAddressing: 'Adresování uzlů',
      nodeAddressingNone: 'Žádné — bez adresy pro uzel',
      nodeAddressingPool: 'Pool — jedna trvalá adresa pro každý obsloužený uzel',
      nodeAddressingHint: 'S Pool přiřadí odvození fabricu každému obslouženému uzlu adresu z rozsahů vyhrazených pro TVirt (po přiřazení trvalá).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Vyhrazené rozsahy',
      dns: 'Servery DNS (oddělené čárkou)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gateway, DNS a trasy deklarované zde jsou jediný zdroj — NIC serverů, Aplikace a síťové služby čerpají odsud',
      routesTitle: 'Statické trasy',
      routeDestination: 'Cíl (CIDR)',
      routeVia: 'Přes (next hop)',
      portUsed: 'Použitý',
      vlanMappings: 'Mapování VLAN',
      vlanTag: 'Tag VLAN',
      vlanNetwork: 'Logická síť',
      nameTaken: 'Název už je ve fabricu použit',
      addNetwork: 'Přidat síť',
      editNetwork: 'Upravit síť',
      deleteNetwork: 'Odebrat síť',
      deleteNetworkConfirm: 'Odebrat logickou síť {name} z fabricu? Její odvozená podsíť v IPAM umírá s ní (odmítnuto, dokud ji používá služba nebo Aplikace). Mapování na portech a LAGG, která na ni ukazují, se odstraní.',
      switchName: 'Přepínač',
      portName: 'Port',
      positionHint: 'Fyzická pozice (volitelná) — stejný slovník jako umístění serverů; jen deklarativní',
      addSwitch: 'Přidat přepínač',
      editSwitch: 'Upravit přepínač',
      deleteSwitch: 'Odebrat přepínač',
      deleteSwitchConfirm: 'Odebrat přepínač {name} se všemi jeho porty? LAGGy se odpovídajícím způsobem zmenší (a pod dvěma porty zaniknou).',
      addPort: 'Přidat port',
      editPort: 'Upravit port',
      deletePort: 'Odebrat port',
      deletePortConfirm: 'Odebrat port {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:síť)',
      taggedShort: 'Tagged',
      portCabling: 'Kabeláž',
      portState: 'Stav',
      stateUnused: 'nepoužitý',
      stateMapped: 'namapovaný',
      laggPortGuard: 'Port, který je členem LAGGu, se upravuje ze strany LAGGu',
      laggsTitle: 'LAGG',
      laggsHint: 'LAGG je 2+ portů v LACP a může přecházet přes přepínače (MLAG, transparentně); vstupují jen nepoužité porty, LAGG je plocha mapování, odebraný port se vrací mezi nepoužité.',
      addLagg: 'Přidat LAGG',
      editLagg: 'Upravit LAGG',
      deleteLagg: 'Odebrat LAGG',
      deleteLaggConfirm: 'Odebrat LAGG {name}? Jeho členské porty se vrátí mezi nepoužité.',
      lacpRate: 'Rate LACP',
      laggPorts: 'Členské porty (2+)',
      laggPortsHint: 'Vstupují jen nepoužité porty — namapovaný port nejdřív uvolněte',
      noNetworks: 'Žádná deklarovaná logická síť.',
      noSwitches: 'Žádný deklarovaný přepínač.',
      noLaggs: 'Žádný deklarovaný LAGG.',
      staleConflict: 'Jiný operátor změnil tento fabric, zatímco jsi ho upravoval: uložení bylo odmítnuto, aby se jeho práce nesmazala. Tvoje změny jsou pořád tady, nedotčené. Aktualizovaný fabric už byl znovu načten: potvrď znovu, ať se použijí navrch, nebo zruš a podívej se, co se změnilo.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Pouze odvozené: každá podsíť se rodí z logické sítě fabricu nebo z overlay sítě — upravuje se u zdroje. Přidělené adresy ukazují, KDO je drží; rozsahy vyhrazené pro TVirt jsou pooly automatického přidělování.',
      search: 'Hledat podle názvu, CIDR nebo adresy',
      empty: 'Žádná síť — deklarujte logickou síť fabricu nebo overlay podsíť: IPAM se z nich odvodí automaticky.',
      reserved: 'Rozsahy vyhrazené pro TVirt',
      address: 'Adresa',
      origin: 'Původ',
      origin_declared: 'deklarováno',
      origin_observed: 'pozorováno',
      holder: 'Drží',
      noAddresses: 'V této podsíti není známa žádná adresa.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Upravit u zdroje'
    },
    firewall: {
      title: 'Skupiny firewallu',
      createTitle: 'Nová skupina firewallu',
      editTitle: 'Upravit skupinu firewallu',
      empty: 'Zatím žádná skupina firewallu — vytvořte jednu: znovupoužitelný slovník pravidel, na který se hostovské NIC odkazují jménem.',
      nameHint: 'Písmena, číslice a vnitřní . - _; jedinečné uvnitř svého scope (stejnojmenné skupiny jinde se rozlišují zápisem /scope/název)',
      description: 'Popis',
      descriptionHint: 'Jeden řádek záměru, zobrazený všude, kde se skupina vybírá',
      enforced: 'Vynucená na scope',
      enforcedHint: 'Vypnuto: čistý slovník — pravidla vážou jen ty NIC, které se na skupinu odkazují. Zapnuto: pravidla vážou každou hostovskou NIC se zapnutým firewallem pod scope skupiny, s odkazem i bez něj.',
      enforcedChip: 'Vynucená',
      enforcedChipHint: 'Pravidla vážou každou hostovskou NIC se zapnutým firewallem pod scope skupiny, s odkazem i bez něj',
      enforceWarning: 'Zapnutím vynucení pravidla svážou KAŽDOU hostovskou NIC se zapnutým firewallem pod {scope} při příští konvergenci, i bez explicitního odkazu — a uvnitř zapnutého chainu je drop předka konečný: úrovně níž ho znovu neotevřou.',
      unenforceInfo: 'Po vypnutí vynucení zůstanou pravidla jen na NIC, které se na skupinu odkazují explicitně.',
      rules: 'Pravidla',
      tabOverview: 'Přehled',
      tabRules: 'Pravidla',
      orderHint: 'Pořadí řádků JE pořadím vyhodnocení uvnitř skupiny: vyhrává první pravidlo, které se shodne.',
      statefulHint: 'Stateful je implicitní: odpovědi na povolený provoz procházejí samy (established/related přijato, invalid zahozen — vkládá je engine, ručně se nepíšou).',
      noRules: 'Žádná pravidla — slovník ve výstavbě: odkázat se na něj je dovolené a nic nevykreslí.',
      addRule: 'Přidat pravidlo',
      direction: 'Směr',
      directionIn: 'Příchozí',
      directionOut: 'Odchozí',
      action: 'Akce',
      action_accept: 'Přijmout',
      action_drop: 'Zahodit',
      action_reject: 'Odmítnout',
      protocol: 'Protokol',
      protocolAny: 'Jakýkoli',
      ports: 'Porty',
      source: 'Zdroj',
      dest: 'Cíl',
      comment: 'Komentář',
      addressHint: 'CIDR IPv4, nebo <fabric>/<logická síť>; prázdné = cokoli',
      moveUp: 'Posunout nahoru',
      moveDown: 'Posunout dolů',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Skupiny firewallu',
      nicGroupsPlaceholder: 'Vyberte skupinu…',
      nicGroupsHint: 'Viditelné skupiny včetně těch z nadřazených scope (použitelné směrem dolů, jako tagy)',
      nicGroupCount: { one: '{n} skupina firewallu', few: '{n} skupiny firewallu', many: '{n} skupiny firewallu', other: '{n} skupin firewallu' },
      nicOff: 'Firewall vypnutý',
      pendingRestartHint: 'Změny firewallu sledují model uloženo/aplikováno: čekají na příští power cycle (PendingRestart). Skupiny vynucené nadřazenými scope platí, když je firewall NIC zapnutý.',
      appConvergeHint: 'Změny firewallu se projeví při příští konvergenci kontejneru. Skupiny vynucené nadřazenými scope platí, když je firewall zapnutý.',
      enforcedAncestors: 'Vynucené nadřazenými scope',
      enforcedAncestorsHint: 'Tato skupina se vztahuje na každou NIC pod svým scope se ZAPNUTÝM firewallem — přepínač je hlavní vypínač NIC (vypnuto = žádný chain, předky včetně); uvnitř zapnutého chainu je autorita předka konečná: jeho drop se níž znovu neotevře.'
    }
  }
}
